import { Box, Divider, Link } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import StyledBanner from "components/Styled/Banner";

export default function DedicatedSupport() {
  const { currentOrg, totalEmailsSent } = useContext(OrganizationUserContext);

  const isVaUser = currentOrg?.isVaUser;

  // Don't show if not a paid user or no emails sent
  if (!isVaUser || totalEmailsSent < 1) {
    return null;
  }

  const planName = "VA Plan";
  const email = "va@onbento.com";

  return (
    <>
      <StyledBanner
        snippet="🎯 Need Support?"
        title="Get personalized help from our team"
        description={
          <>
            As part of your{" "}
            <Box component="span" sx={{ color: "#00BA13", fontWeight: 600 }}>
              {planName}
            </Box>
            , you have access to dedicated human support to help you get the
            most out of Bento. Simply email "request help" to{" "}
            <Link href={`mailto:${email}?subject=Request Help`}>
              <strong>{email}</strong>
            </Link>
            , and our team will provide hands-on, personalized guidance to
            ensure your success.
          </>
        }
      />

      <Divider sx={{ my: 4 }} />
    </>
  );
}
